<template>
  <v-content class="pt-0 mt-0">
  <v-container fluid>
    <pr-loading v-model="loading" />
    <v-snackbar v-model="msg.show" value="true" right top multi-line :color="msg.type" :timeout="msg.time" >
      {{ msg.text }}
      <v-btn dark flat @click="msg.show = false">
        {{ $t('OK') }}
      </v-btn>
    </v-snackbar>

    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('Shipment Tracking') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout row align-content-center justify-center>
            <v-flex xs12>
              <v-layout row>
                <v-flex xs12 sm6 offset-sm3>
                  <template v-if="mode === 'manifest'">
                    <v-text-field
                      v-model="manifest"
                      flat :label="$t('Track.field.manifestClientRef')"
                      :prepend-icon-cb="toggleMode"
                      append-icon="search"
                      @click:append="status"
                      @keyup.enter="status"
                      ref="manifest"
                      autofocus
                    ><template v-slot:prepend>
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="toggleMode">
                              location_searching
                            </v-icon>
                          </template>
                          {{ $t('Track.SwitchTo.barcode') }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <template v-else-if="mode === 'barcode'">
                    <v-text-field
                      v-model="barcode"
                      flat :label="$t('Track.field.barcode')"
                      :prepend-icon-cb="toggleMode"
                      append-icon="search"
                      @click:append="status"
                      @keyup.enter="status"
                      ref="barcode"
                    ><template v-slot:prepend>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" @click="toggleMode">
                              qr_code_2
                            </v-icon>
                          </template>
                          {{ $t('Track.SwitchTo.manifestClientRef') }}
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-if="manifestId">
                <v-flex xs10 offset-xs1>
                  <v-card>
                    <v-toolbar color="light-blue" dark extended>
                      <v-toolbar-title class="layout">
                        <v-text-field
                          prepend-icon="local_shipping"
                          :value="manifestId"
                          :label="$t('Manifest')"
                          readonly
                        ></v-text-field>
                        <v-text-field v-if="clientRef"
                          :value="clientRef"
                          :label="$t('Reference')"
                          readonly
                          class="mx-2"
                        ></v-text-field>

                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <span v-if="currentState != 5">
                        <v-tooltip v-if="shipmentId" bottom>
                          <v-icon small class="mx-2" slot="activator">event</v-icon>
                          {{ $t('Expected delivery') }}
                        </v-tooltip>
                        <span>{{ printDateTime( target_after, 1 ) }} &nbsp; {{ printDateTime( target_after, 2 ) }} - {{ printDateTime( target_until, 2 ) }}</span>
                      </span>
                      <v-tooltip v-if="shipmentId" bottom>
                        <v-btn icon flat slot="activator" @click="editItem(shipmentId)">
                          <v-icon>info</v-icon>
                        </v-btn>
                        <span>{{ $t("Details") }}</span>
                      </v-tooltip>
                      <template v-slot:extension>
                        <tracking-progress :currentStep="currentState" color="rgba(255, 255, 255, 0.5)"></tracking-progress>
                      </template>
                    </v-toolbar>
                    <v-data-table
                      :headers="headers"
                      :items="history"
                      item-key="stateSettingDate"
                      :total-items="history.length"
                      hide-actions
                      class="elevation-1 tracking-table"
                    >
                      <template slot="items" slot-scope="props">
                      <tr :class="{hasDescription: props.item.description}" @click="props.expanded = !props.expanded">
                        <td class="text-xs-left">{{ new Date(props.item.stateSettingDate).toLocaleString() }}</td>
                        <td>
                          <v-icon small class="mr-2">{{ stateIcon(props.item.shipmentRoutingState) }}</v-icon>
                          {{ $t('ShipmentRoutingState.' + props.item.shipmentRoutingState.code) }}
                        </td>
                        <td class="text-xs-left">{{ props.item.station ? props.item.station.name : '' }}</td>
                        <td class="text-xs-center no-wrap pa-0 pr-2">
                          <v-tooltip bottom v-if="props.item.description && props.item.shipmentRoutingState.code !== 'IIIIJ'">
                            <v-icon slot="activator" color="light-blue">comment</v-icon>
                            {{ $t('Comment') }}: {{ props.item.description }}
                          </v-tooltip>
                          <v-tooltip bottom v-if="props.item.shipmentRoutingState.code == 'CCCCS'">
                            <v-icon slot="activator" class="ml-2">home</v-icon>
                            {{ $t('Source Address') }}: {{ source_address }}
                          </v-tooltip>
                          <template v-else-if="props.item.shipmentRoutingState.code.match('^F.+')">
                            <v-tooltip bottom>
                              <v-icon slot="activator" class="ml-2">home</v-icon>
                              {{ $t('Target Address') }}: {{ target_address }}
                            </v-tooltip>
                          </template>
                          <template v-if="props.index === 0 && pods.length > 0">
                            <v-tooltip bottom class="mr-2">
                              <v-badge slot="activator" color="light-blue" overlap>
                                <template v-slot:badge>
                                  <span>{{ pods.length }}</span>
                                </template>
                                <v-icon>attach_file</v-icon>
                              </v-badge>
                              <div v-for="(pod, idx) in pods" :key="idx">
                                <span class="font-weight-bold mr-2"> {{ pod.fileName }} </span>
                                <span> {{ printDateTime(pod.fileDate, 1) }} </span>
                              </div>
                            </v-tooltip>
                            <!-- archive, attach_file, attachment, insert_drive_file, description -->
                          </template>
                        </td>
                      </tr>
                      </template>
                      <template slot="expand" slot-scope="props">
                        <v-card flat v-if="props.item.description && props.item.description != '' && props.item.shipmentRoutingState.code !== 'IIIIJ'" class="expanded-card">
                          <v-card-text class="py-2">
                            <v-icon class="mr-2" small color="light-blue">comment</v-icon>
                            <span class="grey--text text--darken-1 font-weight-light">{{ $t('Comment') }}: </span>
                            {{ props.item.description }}
                          </v-card-text>
                        </v-card>
                        <v-card flat v-if="props.item.shipmentRoutingState.code == 'CCCCS'" class="expanded-card">
                          <v-card-text class="py-2">
                            <v-icon class="mr-2" small>home</v-icon>
                            <span class="grey--text text--darken-1 font-weight-light">{{ $t('Source Address') }}: </span>
                            {{ source_address }}
                          </v-card-text>
                        </v-card>
                        <v-card flat v-else-if="props.item.shipmentRoutingState.code.match('^F.+')" class="expanded-card">
                          <v-card-text class="py-2">
                            <v-icon class="mr-2" small>home</v-icon>
                            <span class="grey--text text--darken-1 font-weight-light">{{ $t('Target Address') }}: </span>
                            {{ target_address }}
                          </v-card-text>
                        </v-card>
                        <v-card flat v-if="props.index === 0 && pods.length > 0" class="expanded-card">
                          <v-card-text class="pa-2">
                            <!-- <v-icon class="mr-2" small>attach_file</v-icon> -->
                            <template v-for="(pod, idx) in pods">
                              <v-tooltip bottom :key="idx">
                                <template v-slot:activator="{ on }">
                                  <v-chip v-on="on" small class="caption attached-pod" @click="downloadPod(pod.id)">
                                    <v-avatar color="light-blue"><v-icon color="white" small>attach_file</v-icon></v-avatar>
                                    <span class="font-weight-bold mr-2">{{ pod.name }}</span>
                                    <span class="mr-2">{{ pod.fileName }}</span>
                                    <span class="blue--text mr-2">{{ (pod.fileSize / 1000).toFixed(1) }} KB</span>
                                    <span class="blue--text">{{ printDateTime(pod.fileDate) }}</span>
                                  </v-chip>
                                </template>
                                <span>{{ $t('Download POD') }}</span>
                              </v-tooltip>
                            </template>
                          </v-card-text>
                        </v-card>
                      </template>
                      <template slot="no-data">
                        {{ failure }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs10 offset-xs1>
                  <v-alert type="error" :value="failure">
                    {{ failure }}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
  </v-content>
</template>

<script>
import { tracking, attachments } from '../resources';
import { getStateIcon, downloadFile, msg } from '../components/util';
import PrLoading from '@/components/Loading';
import TrackingProgress from '@/components/TrackingProgress';

const ignoreStates = ['AAAA', 'CCCC', 'CCCCOAD', 'CCCCOAK', 'CCCCSKD', 'CCCCSKW', 'CCCCSSE', 'CCCCSTN', 'CCFFG', 'CCFFJ', 'CCFFN', 'CCFFT', 'DDDDB', 'FFFFD', 'FFFFE', 'FFFFF', 'FFFFI', 'FFFFJ', 'HHHHK', 'HHHHM', 'IIIIA'];

export default {
  components: {
    PrLoading,
    TrackingProgress
  },

  props: ['id'],

  data() {
    return {
      msg,

      loading: false,

      shipmentId: null,
      history: [],
      pods: [],
      source_address: '',
      target_address: '',
      target_after: '',
      target_until: '',
      failure: '',
      headers: [
        { text: this.$t('Date'),           value: 'date',    sortable: false },
        { text: this.$t('Tracking State'), value: 'name',    sortable: false },
        { text: this.$t('Station'),        value: 'station', sortable: false },
        { text: '',                                          sortable: false },
      ],
      currentState: 0, // 0-5
      manifest: '',
      barcode: '',
      mode: 'manifest',
      manifestId: '',
      clientRef: ''
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    id(val) {
      this.init();
    },
  },
  methods: {
    init() {
      if (this.id) {
        this.manifest = this.id;
        this.status();
      }
    },

    stateIcon(e) {
      return getStateIcon(e).stateIcon;
    },

    status() {
      let id = this[this.mode];
      if (!id) {
        console.log('Status for empty manifest ignored');
        return;
      }
      if (this.loading) {
        console.log('Already loading manifest tracking');
        return;
      }
      this.loading = true;

      tracking.track({
        id: id.trim(),
        mode: this.mode
      }).then(response => {
        let b = response.body;
        this.manifestId = "";
        this.clientRef = "";
        this.failure = "";
        if (b.shipment_id) {
          this.shipmentId = b.shipment_id;
          this.manifestId = b.manifest_id;
          if (b.client_ref)
            this.clientRef = b.client_ref;
          this.history = b.history ? b.history.filter(elem => {
            return !!elem.shipmentRoutingState && !ignoreStates.includes(elem.shipmentRoutingState.code)// !elem.shipmentRoutingState || (elem.shipmentRoutingState && !elem.shipmentRoutingState.code.startsWith("IIII"))
            }) : [];
          this.source_address = b.source && b.source.address ? b.source.address : "";
          this.target_address = b.target && b.target.address ? b.target.address : "";
          this.target_after   = b.target && b.target.after ? b.target.after : "";
          this.target_until   = b.target && b.target.until ? b.target.until : "";
          this.currentState = !!b.progress ? Math.round(b.progress/20) : 0;
          if (this.currentState < 0)
            this.currentState = 0;
          else if (this.currentState > 5)
            this.currentState = 5;
          this.podInfo(this.shipmentId);
        }
        else
        if (b.errors) {
          this.currentState = 0;
          this.history = [];
          b.errors.forEach(element => {
            if (this.failure.length > 0)
              this.failure = this.failure + ", ";
            this.failure = this.failure + element.text;
          });
        }
      }).catch(response => {
        this.msg.popup((
          response.status === 403 ?  this.$t("Access denied") : response.statusText
        ), 'error');
        console.log("Error loading track state, Status: " + response.status, response.body);
      }).finally(() => {
        this.loading = false;
      });
    },

    podInfo(shipmentId) {
      this.loading = true;
      attachments.podInfo({shipmentId}).then(r => {
        this.pods = r.body.pods;
      }).catch(e => {
        this.msg.popup(this.$t('Error loading pod info'), 'error');
        this.pods = [];
        console.log("Error pod info", e)
      }).finally(() => {
        this.loading = false;
      });
    },

    downloadPod(attachmentId) {
      this.loading = true;
      let shipmentId = this.shipmentId;
      attachments.podLoad({shipmentId, attachmentId}).then(r => {
        downloadFile(r);
      }).catch(e => {
        this.msg.popup(this.$t('Error downloading pod'), 'error');
        console.log("Error downloading pod", e);
      }).finally(() => {
        this.loading = false;
      });
    },

    editItem(id) {
      this.$router.push({ name : "request", params: { id }});
    },

    printDateTime(datetime, dateOrTime) {
      if (!datetime) return '';
      let d = new Date( datetime ),
          year  = d.getFullYear(),
          month = ('0' + (d.getMonth()+1) ).slice(-2),
          day   = ('0' + d.getDate() ).slice(-2),
          hour  = ('0' + d.getHours() ).slice(-2),
          min   = ('0' + d.getMinutes() ).slice(-2);

      if (dateOrTime && dateOrTime == 1)
        return `${year}-${month}-${day}`;
      else if (dateOrTime && dateOrTime == 2)
        return `${hour}:${min}`;
      else
        return `${year}-${month}-${day} ${hour}:${min}`;
    },

    toggleMode() {
      this.mode = this.mode === 'barcode' ? 'manifest' : 'barcode';
      setTimeout(() => this.$refs[this.mode].focus(), 500);
    },
  }
}
</script>

<style scoped>
.tracking-table .hasDescription {
  background-color: #03a9f433;
}
.tracking-table td {
  line-height: 1.1rem;
}
.expanded-card {
  border-bottom: 1px dotted rgba(0,0,0,0.12);
}
.expanded-card:last-child {
  border-bottom-style: solid;
}
</style>